import React, { useEffect, useState } from "react";
import logo from "./netflix-logo.png";
import "./Nav.css";

function Nav() {
  const [show, handleShow] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 500) {
        //handles off
        handleShow(true);
      } else handleShow(false);
    });
    return () => {
      window.removeEventListener("scroll");
    };
  }, []);
  return (
    <div className={`nav ${show && "nav_black"}`}>
      <img className="netflix-logo" src={logo} alt="logo" />
      <button className="netflix-button">Sign in</button>
    </div>
  );
}

export default Nav;
